import { FC } from "react";

import {
    RouteEditorModal,
    RouteEditorModalPayloads,
} from "@/pages/SV/RouteManagement/RouteEditor/RouteEditor.types";
import { BaseModal } from "@/shared/ui/BaseModal";
import { PrimaryText } from "@/shared/ui/Typography";

import { StyledInfoCircleOutlined } from "./Styled";

interface WarningDebtModalProps {
    onClose: () => void;
    payload: RouteEditorModalPayloads[RouteEditorModal.WarningDebt];
}

export const WarningDebtModal: FC<WarningDebtModalProps> = ({
    onClose,
    payload,
}) => {
    const { isMultiSelect } = payload;

    const warningDebtText = isMultiSelect
        ? "Одна з торгових точок має незакриту дебіторську заборгованість. Потрібно погасити борг для видалення її з маршруту"
        : "Торгова точка має незакриту дебіторську заборгованість. Потрібно погасити борг для видалення її з маршруту";

    return (
        <BaseModal
            open
            onClose={onClose}
            title={"Неможлива дія"}
            hideConfirm
            cancelText="Повернутися назад"
            icon={<StyledInfoCircleOutlined />}
        >
            <PrimaryText>{warningDebtText}</PrimaryText>
        </BaseModal>
    );
};
